import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './city_seal@64.webp'
import _imports_1 from './pbot-verticalapps-logo_dark@64.webp'


const _hoisted_1 = { class: "grid grid-cols-1 gap-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "font-semibold text-lg" }, "City of Portland, Oregon", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-wrap space-x-3 md:space-x-0 lg:space-x-3" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "max-w-16 max-h-16",
    alt: "Portland City Seal",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "max-h-16",
    alt: "PBOT Vertical Applications logo",
    src: _imports_1
  })
], -1)
const _hoisted_4 = { class: "text-gray-700 text-base" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("small", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, "© Copyright " + _toDisplayString(_ctx.copyrightDate), 1)
    ])
  ]))
}